/*  ========================================================================
    # Scripts - Double image pararllax
    ========================================================================  */

/**
 * Script that checkts if an element is in view
 */

const ElementInView = {
  cfg: {
    inViewElements: document.querySelectorAll('[data-in-view]')
  },

  /**
   * Handle in element in view
   */
  handleInViewElement() {
    const intersectionObserver = new IntersectionObserver(
      (entries, observe) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.dataset.inView = true;
            setTimeout(() => {
              entry.target.classList.add('animation-finished');
            }, 1000);
            observe.unobserve(entry.target);
          }
        });
      },
      {
        threshold: [0.4]
      }
    );

    this.cfg.inViewElements.forEach(entry => {
      intersectionObserver.observe(entry);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.inViewElements && this.cfg.inViewElements.length > 0) {
      this.handleInViewElement();
    }
  }
};

export default ElementInView;
